<admin-header [primaryButtons]="headerPrimaryButtons" title="Opportunity Pipeline" (eventFired)="headerButtonClick($event)"></admin-header>

<div class="pipeline-toolbar">
    <div class="pipeline-search">
        <i class="fal fa-search"></i>
        <input type="text" placeholder="Search opportunities..." [(ngModel)]="searchText" (ngModelChange)="buildColumns()">
    </div>
    <div class="pipeline-filter">
        <dx-select-box [items]="userProfiles" displayExpr="fullName" valueExpr="id" [(value)]="filterAssignedUserId" (onValueChanged)="buildColumns()" [searchEnabled]="true" [showClearButton]="true" placeholder="Filter by assigned to..." [width]="240"></dx-select-box>
    </div>
</div>

<div class="pipeline-board">
    <div *ngFor="let col of columns" class="pipeline-column">
        <div class="pipeline-column-header" [style.borderTopColor]="getStageColor(col.stage.id)">
            <span class="pipeline-column-title">{{ getStageName(col.stage.id) }}</span>
            <span class="pipeline-column-badge">{{ col.items.length }}</span>
        </div>
        <div class="pipeline-column-body">
            <dx-sortable
                group="opportunities"
                [data]="col"
                itemOrientation="vertical"
                dragDirection="both"
                (onAdd)="onCardDrop($event)"
                (onReorder)="onCardReorder($event)"
                class="pipeline-sortable">
                <div *ngFor="let opp of col.items" class="pipeline-card" [class.pipeline-card-expanded]="expandedCardId === opp.id" [style.borderLeftColor]="getStageColor(col.stage.id)" (click)="viewOpportunity(opp.id)">
                    <div class="pipeline-card-title"><i *ngIf="opp.isSensitive" class="fal fa-lock" style="color:#dc3545; margin-right:4px" title="Sensitive"></i>{{ opp.title }}</div>
                    <div class="pipeline-card-value" *ngIf="opp.value">£{{ opp.value | number:'1.0-0' }}</div>
                    <div class="pipeline-card-meta">
                        <span *ngIf="opp.expectedCloseDate">
                            <i class="fal fa-calendar"></i> {{ opp.expectedCloseDate | date:'dd/MM/yy' }}
                        </span>
                    </div>
                    <div class="pipeline-card-lead" *ngIf="opp.crmLeadId">
                        <i class="fal fa-building"></i> {{ getLeadName(opp.crmLeadId) }}
                    </div>
                    <div class="pipeline-card-lead" *ngIf="opp.assignedUserId">
                        <i class="fal fa-user"></i> {{ getAssignedName(opp.assignedUserId) }}
                    </div>
                    <div class="pipeline-card-actions">
                        <button class="pipeline-card-btn" (click)="toggleCardExpand(opp.id, $event)" [title]="expandedCardId === opp.id ? 'Hide tasks' : 'Show tasks'">
                            <i class="fal fa-tasks"></i>
                            <span *ngIf="tasksByOpportunity[opp.id]?.length" class="pipeline-task-count">{{ tasksByOpportunity[opp.id].length }}</span>
                        </button>
                        <button class="pipeline-card-btn" (click)="addTask(opp.id, $event)" title="Add task">
                            <i class="fal fa-plus"></i>
                        </button>
                    </div>
                    <div class="pipeline-card-tasks" *ngIf="expandedCardId === opp.id" (click)="$event.stopPropagation()">
                        <div *ngIf="!tasksByOpportunity[opp.id] || tasksByOpportunity[opp.id].length === 0" class="pipeline-tasks-empty">No tasks</div>
                        <div *ngFor="let task of tasksByOpportunity[opp.id]" class="pipeline-task-item" [class.pipeline-task-done]="task.isCompleted">
                            <input type="checkbox" [checked]="task.isCompleted" (change)="toggleTaskComplete(task, $event)">
                            <div class="pipeline-task-info">
                                <span class="pipeline-task-title">{{ task.title }}</span>
                                <span class="pipeline-task-meta" *ngIf="task.dueDate || task.assignedToUserProfileId || task.completedDate">
                                    <span *ngIf="task.completedDate"><i class="fal fa-check"></i> {{ task.completedDate | date:'dd/MM' }}</span>
                                    <span *ngIf="task.dueDate && !task.isCompleted"><i class="fal fa-calendar"></i> {{ task.dueDate | date:'dd/MM' }}</span>
                                    <span *ngIf="task.assignedToUserProfileId"><i class="fal fa-user"></i> {{ getAssignedName(task.assignedToUserProfileId) }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pipeline-empty" *ngIf="col.items.length === 0">
                    <i class="fal fa-inbox"></i>
                    <span>No opportunities</span>
                </div>
            </dx-sortable>
        </div>
    </div>
</div>

<div *ngIf="addTaskVisible" class="pipeline-modal-backdrop" (click)="closeAddTask()">
    <div class="pipeline-modal" (click)="$event.stopPropagation()">
        <div class="pipeline-modal-header">
            <span class="pipeline-modal-title">Add Task</span>
            <button class="pipeline-modal-close" (click)="closeAddTask()">&#x2715;</button>
        </div>
        <div class="pipeline-modal-body">
            <dx-form [(formData)]="addTaskNewTask" labelLocation="top" [colCount]="1">
                <dxi-item dataField="title"><dxo-label text="Title"></dxo-label></dxi-item>
                <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: 60 }"><dxo-label text="Description"></dxo-label></dxi-item>
                <dxi-item dataField="dueDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date', showClearButton: true }"><dxo-label text="Due Date"></dxo-label></dxi-item>
                <dxi-item dataField="assignedToUserProfileId" editorType="dxSelectBox" [editorOptions]="{ items: userProfiles, displayExpr: 'fullName', valueExpr: 'id', searchEnabled: true, showClearButton: true, placeholder: 'Assign to...' }"><dxo-label text="Assigned To"></dxo-label></dxi-item>
            </dx-form>
        </div>
        <div class="pipeline-modal-footer">
            <button class="btn btn-outline-secondary btn-sm" (click)="closeAddTask()">Cancel</button>
            <button class="btn btn-primary btn-sm" (click)="saveAddTask()">Add Task</button>
        </div>
    </div>
</div>
